import { safeParseJson } from '../utils/safeParseJson';

const KEY = 'dg_offline_grade_sync_intent_v1';

export type OfflineGradeSyncIntent = {
  /** Indices into `gradedWorks` / `dg_pending_sync` at save time */
  indexes: number[];
  post: boolean;
  email: boolean;
  drive: boolean;
  savedAt: number;
};

export function getOfflineGradeSyncIntent(): OfflineGradeSyncIntent | null {
  if (typeof window === 'undefined') return null;
  const raw = safeParseJson<unknown>(window.localStorage.getItem(KEY), null);
  if (!raw || typeof raw !== 'object') return null;
  const o = raw as Record<string, unknown>;
  const indexes = o.indexes;
  if (!Array.isArray(indexes) || !indexes.every((n) => typeof n === 'number' && Number.isFinite(n)))
    return null;
  if (typeof o.post !== 'boolean' || typeof o.email !== 'boolean' || typeof o.drive !== 'boolean')
    return null;
  if (typeof o.savedAt !== 'number') return null;
  return {
    indexes: indexes.map((n) => Math.floor(n)),
    post: o.post,
    email: o.email,
    drive: o.drive,
    savedAt: o.savedAt,
  };
}

export function saveOfflineGradeSyncIntent(intent: Omit<OfflineGradeSyncIntent, 'savedAt'>): void {
  if (typeof window === 'undefined') return;
  const row: OfflineGradeSyncIntent = {
    ...intent,
    savedAt: Date.now(),
  };
  try {
    window.localStorage.setItem(KEY, JSON.stringify(row));
  } catch {
    /* quota */
  }
}

export function clearOfflineGradeSyncIntent(): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

export function isOfflineGradeSyncIntentValid(
  intent: OfflineGradeSyncIntent,
  gradedWorksLength: number
): boolean {
  if (gradedWorksLength <= 0 || intent.indexes.length === 0) return false;
  return intent.indexes.every((i) => i >= 0 && i < gradedWorksLength);
}
